import React, { useState } from 'react';
import './YoutubVideo.css';
import { AnimatedSection } from '../../AnimatedSection';

const YoutubVideo = ({ videoTitle, videoDescription, videoUrl }) => {
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlayClick = () => {
        setIsPlaying(true);
    };
    return (
        <div className="container px-4 sm:px-6 lg:px-8 flex flex-col gap-20  !mt-40">

            <div className='text-3xl md:text-8xl text-white text-center font-bold'>
                {videoTitle}
            </div>
            <div className="flex justify-center content-description text-center !pt-0 w-100">
                <p className='"w-full md:w-2/4"'>{videoDescription}</p>
            </div>
            <div style={{ width: "100%", height: "100%" }}>
                <iframe
                    src={videoUrl}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                        width: "100%",
                        aspectRatio: "3 / 2", // 1.5 : 1 ratio (width : height)
                        border: "0"
                    }}
                />
            </div>
        </div>
    );
};

export default YoutubVideo;
